import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";
import { useConciliacaoAuttarAdicionar } from "@/Services/Financeiro/Conta/ConciliacaoAuttarService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, notification, Row, Upload } from "antd";
import { AxiosResponse } from "axios";
import { useRef } from "react";
export interface IConciliacaoAuttarFormModalProps extends IModalBaseProps {
    codTrabalhoTipo:EnumTrabalhoTipo;
    onSuccess?(data: AxiosResponse<void, any>, variables: File, context: unknown) : void;
}
export default function ConciliacaoAuttarFormModal({
    onOk,
    onCancel,
    onSuccess,
    codTrabalhoTipo,
    ...rest
}:IConciliacaoAuttarFormModalProps) {
    const [form] = Form.useForm();
    const refModal = useRef<ModalBaseRefType|null>(null);

    const {
        mutate,
        isPending
    } = useConciliacaoAuttarAdicionar({
        codTrabalhoTipo,
        onSuccess(data, variables, context) {
            refModal.current?.fechar();

            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Carregado com sucesso."
            });

            onSuccess?.(data, variables, context);
        },
    });
    
    return <ModalBase 
        {...rest}
        ref={refModal}
        onOk={(e) => {
            form.submit();
            onOk?.(e);
        }}
        onCancel={(e) => {
            form.resetFields();
            refModal.current?.fechar();
            onCancel?.(e);
        }}
        confirmLoading={isPending}
    >
        <Form<{arquivo:File}>
            layout="vertical"
            autoComplete="off"
            form={form}
            onFinish={(data) => {
                mutate(data.arquivo);
            }}
        >
            <Row gutter={8} wrap>
                <Col
                    xs={24}
                >
                    <Form.Item name={["arquivo"]} getValueFromEvent={({file}) => file}>
                        <Upload maxCount={1} beforeUpload={() => false} multiple={false}>
                            <Button icon={<UploadOutlined />}>Carregar arquivo</Button>
                        </Upload>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </ModalBase>
}